import { CssBaseline, ThemeProvider } from '@mui/material';
import { type ThemeOptions } from '@mui/material/styles';
import { useLayoutEffect, useMemo } from 'react';
import { applyThemeVars, themeVars, type ThemeMode } from './theme-vars';
import { createMuiTheme } from './mui-theme';

export type SGSThemeProviderProps = {
  children: React.ReactNode;
  mode?: ThemeMode;
  themeOverrides?: ThemeOptions;
};

export function SGSThemeProvider({ children, mode = 'default', themeOverrides }: SGSThemeProviderProps) {
  const theme = useMemo(() => createMuiTheme(mode, themeOverrides), [mode, themeOverrides]);
  const cssVars = useMemo(() => {
    const vars = themeVars[mode];
    const entries = Object.entries(vars)
      .map(([key, value]) => `${key}:${value};`)
      .join('');
    return `:root{${entries}}`;
  }, [mode]);

  useLayoutEffect(() => {
    applyThemeVars(mode);
  }, [mode]);

  return (
    <ThemeProvider theme={theme}>
      <style data-theme-vars="sgs" dangerouslySetInnerHTML={{ __html: cssVars }} />
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
